import { combineReducers } from 'redux';
import {
    REQUEST_ACCOUNT_EBONS,
    RECEIVE_ACCOUNT_EBONS,
    FAILURE_ACCOUNT_EBONS,
    RECEIVE_ACCOUNT_EBONS_CODE
} from './constants';

const ebonOrders = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_EBONS:
            return action.response.payload;
        default:
            return state;
    }
};

const ebonOrderWithCodes = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_EBONS_CODE:
            const orderId = action.response.payload.id ? action.response.payload.id : -1;
            const newState = state.slice().filter(order => order.id !== orderId);
            newState.push(action.response.payload);
            return newState;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ACCOUNT_EBONS:
            return true;
        case FAILURE_ACCOUNT_EBONS:
        case RECEIVE_ACCOUNT_EBONS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ACCOUNT_EBONS:
            return action.response.message;
        case REQUEST_ACCOUNT_EBONS:
        case RECEIVE_ACCOUNT_EBONS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    ebonOrders,
    ebonOrderWithCodes,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/ebons/reducer.js